// eslint-disable-next-line import/no-extraneous-dependencies
import { FastAverageColor } from 'fast-average-color';
import type { FastAverageColorResource, FastAverageColorRgba } from 'fast-average-color';

const fac = new FastAverageColor();

interface CalculateImageColorOptions {
  algorithm?: 'simple' | 'sqrt' | 'dominant';
  ignoredColors?: [number, number, number][] | [number, number, number, number][];
}

const defaultOptions: CalculateImageColorOptions = {
  algorithm: 'dominant',
  ignoredColors: [
    [255, 255, 255],
    [0, 0, 0],
  ], // Default to ignoring white and black
};

export const calculateImageColor = async (
  resource: FastAverageColorResource,
  options: CalculateImageColorOptions = {}
): Promise<string | null> => {
  try {
    const color = await fac.getColorAsync(resource, {
      algorithm: options.algorithm || defaultOptions.algorithm,
      ignoredColor: (options.ignoredColors || defaultOptions.ignoredColors) as FastAverageColorRgba[],
    });

    return color.rgba;
  } catch (e) {
    console.error('Error calculating image color:', e);
    return null;
  }
};